import React, { useContext, useState } from 'react'
import { withTranslationCustom } from 'lib/i18next'

import { Field } from 'formik'
import { ExtendedFormikContext } from 'components/Forms/ExtendedFormik'
import { RefillEventFormContext } from 'components/Events/EventForm/RefillEventForm/RefillEventForm'
import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import NumberField from 'components/Forms/FormElements/NumberField'
import Checkbox from 'components/Forms/FormElements/Checkbox'
import InfoBox from 'components/UI/InfoBox/InfoBox'

import './event-form-refill-module.pcss'

const EventFormRefillModule = ({ t }) => {
    const { values, setFieldValue } = useContext(ExtendedFormikContext)
    const { vehicle } = useContext(RefillEventFormContext)

    const readStateValues = () => {
        return {
            fuelPrice: values.fuelPrice,
            fuelAmount: values.fuelAmount,
            fuelTotalPrice: values.fuelTotalPrice,
        }
    }

    // Use calculationState as start point to calculate values as values may change during calculation
    // and we need to know what values were empty when calculating started.
    const [calculationState, setCalculationState] = useState(readStateValues())
    const [calculatedField, setCalculatedField] = useState(null)

    const handleFocus = () => {
        setCalculationState(readStateValues())
    }

    const handleFuelAmountChange = (allowOverwrite) => {
        return (e) => {
            const fuelPrice = calculationState.fuelPrice
            const fuelAmount = e.target.value
            const fuelTotalPrice = calculationState.fuelTotalPrice

            if (fuelAmount && fuelTotalPrice && !fuelPrice) {
                calculatePrice(fuelTotalPrice, fuelAmount)
            } else if (fuelAmount && fuelPrice && (allowOverwrite || !fuelTotalPrice)) {
                calculateTotalPrice(fuelAmount, fuelPrice)
            }
        }
    }

    const handleFuelTotalPriceChange = (allowOverwrite) => {
        return (e) => {
            const fuelPrice = calculationState.fuelPrice
            const fuelAmount = calculationState.fuelAmount
            const fuelTotalPrice = e.target.value

            if (fuelTotalPrice && fuelAmount && (allowOverwrite || !fuelPrice)) {
                calculatePrice(fuelTotalPrice, fuelAmount)
            } else if (fuelTotalPrice && fuelPrice && (allowOverwrite || !fuelAmount)) {
                calculateAmount(fuelTotalPrice, fuelPrice)
            }
        }
    }

    const handleFuelPriceChange = (allowOverwrite) => {
        return (e) => {
            const fuelPrice = e.target.value
            const fuelAmount = calculationState.fuelAmount
            const fuelTotalPrice = calculationState.fuelTotalPrice

            if (fuelPrice && fuelAmount && (allowOverwrite || !fuelTotalPrice)) {
                calculateTotalPrice(fuelAmount, fuelPrice)
            } else if (fuelPrice && fuelTotalPrice && (allowOverwrite || !fuelAmount)) {
                calculateAmount(fuelTotalPrice, fuelPrice)
            }
        }
    }

    const calculateAmount = (fuelTotalPrice, fuelPrice) => {
        setFieldValue('fuelAmount', parseFloat((fuelTotalPrice / fuelPrice).toFixed(2)))
        setCalculatedField('fuelAmount')
    }

    const calculateTotalPrice = (fuelAmount, fuelPrice) => {
        setFieldValue('fuelTotalPrice', parseFloat((fuelAmount * fuelPrice).toFixed(2)))
        setCalculatedField('fuelTotalPrice')
    }

    const calculatePrice = (fuelTotalPrice, fuelAmount) => {
        setFieldValue('fuelPrice', parseFloat((fuelTotalPrice / fuelAmount).toFixed(3)))
        setCalculatedField('fuelPrice')
    }

    return (
        <EventFormModule className="event-form-refill-module">
            <div className="event-form-refill-module__calculate">
                <NumberField
                    className={calculatedField === 'fuelAmount' ? 'event-form-refill-module__field--last-calculated' : ''}
                    name="fuelAmount"
                    label={t('events:forms.fuelAmount.label')}
                    unitsTip="l"
                    onFocus={handleFocus}
                    onChange={handleFuelAmountChange(true)}
                    onBlur={handleFuelAmountChange(false)}
                />
                <NumberField
                    className={calculatedField === 'fuelTotalPrice' ? 'event-form-refill-module__field--last-calculated' : ''}
                    name="fuelTotalPrice"
                    label={t('events:forms.fuelTotalPrice.label')}
                    unitsTip="€"
                    onFocus={handleFocus}
                    onChange={handleFuelTotalPriceChange(true)}
                    onBlur={handleFuelTotalPriceChange(false)}
                />
                <NumberField
                    className={calculatedField === 'fuelPrice' ? 'event-form-refill-module__field--last-calculated' : ''}
                    name="fuelPrice"
                    decimals={3}
                    label={t('events:forms.fuelPrice.label')}
                    unitsTip="€/l"
                    onFocus={handleFocus}
                    onChange={handleFuelPriceChange(true)}
                    onBlur={handleFuelPriceChange(false)}
                />
            </div>
            <div className="event-form-refill-module__fill-up">
                <Field name="fuelFilledUp">
                    {(props) => (
                        <Checkbox
                            {...props}
                            label={t('events:forms.fuelFilledUp.label')}
                        />
                    )}
                </Field>
                {(values.fuelFilledUp && !vehicle.hasFilledUpEvent) && (
                    <InfoBox
                        initStartExpanded
                        shortText={t('events:forms.fuelFilledUp.fuelConsumptionTip.label')}
                    >
                        {t('events:forms.fuelFilledUp.fuelConsumptionTip.text')}
                    </InfoBox>
                )}
            </div>
        </EventFormModule>
    )
}

export default withTranslationCustom('events')(EventFormRefillModule)
